import { EnvironmentNames } from "@origin-digital/platform-enums";
import { FeatureFlags } from "@origin-digital/feature-flags";

/**
 * Available list of TAL feature flags, please use camelCase for future flags.
 *
 * The intention of these flags is to allow testers to test features that are deployed but not yet ready for release. Once the feature is fully released, the flag should be removed.
 * These feature flags are not intended to be long-living or operational.
 *
 * Additionally, these flags are owned by platform team (prefixed with `tal`). If you need to make changes, please discuss with platform team first.
 */
export const FEATURE_FLAGS = {
  CHAT_CLIENT_SDK: "talChatClientSdk",
  PROPERTY_SELECTOR: "talPropertySelector",
  TOKEN_SHIELD: "tal_token_shield",
  MULTIPLE_INTERNET_SERVICES_PER_PROPERTY:
    "internetMultipleServicesPerProperty",
} as const;

// String Literal Union of all possible features. Created for convenient/clearer inferred typing
type Feature = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export const defaultFeatures: Record<Feature, boolean> = {
  [FEATURE_FLAGS.CHAT_CLIENT_SDK]: false,
  [FEATURE_FLAGS.PROPERTY_SELECTOR]: false,
  [FEATURE_FLAGS.TOKEN_SHIELD]: true,
  [FEATURE_FLAGS.MULTIPLE_INTERNET_SERVICES_PER_PROPERTY]: true,
};

const envFeatureOverrides: Partial<
  Record<EnvironmentNames, Partial<Record<Feature, boolean>>>
> = {
  staging: { [FEATURE_FLAGS.CHAT_CLIENT_SDK]: true },
  prod: { [FEATURE_FLAGS.CHAT_CLIENT_SDK]: false },
};

export const getDefaultFeatures = (env?: EnvironmentNames): FeatureFlags => {
  return { ...defaultFeatures, ...(env ? envFeatureOverrides[env] : {}) };
};
